import * as React from 'react';
import { useState } from 'react';
import Selector from 'components/inputs/Selector';
import { ParameterCustomInputProps } from './types';

const ParameterBooleanInput = ({
    value,
    setParameterValue,
    parameterName,
}: ParameterCustomInputProps): React.ReactElement => {
    // local state because debounce on setParameterValue disable real-time modification
    const [selectedValue, setSelectedValue] = useState(value);
    // @ts-expect-error [TS migration] Was not detected by flow
    const onChange = (changedValue) => {
        setParameterValue(parameterName, changedValue);
        setSelectedValue(changedValue);
    };
    return (
        <Selector
            value={`${selectedValue.toString()}`}
            options={[
                { value: true, label: 'True' },
                { value: false, label: 'False' },
            ]}
            onChange={onChange}
            className="parameter-value text"
            variant="outlined"
            fullWidth={false}
        />
    );
};

export default ParameterBooleanInput;
